import { useState, useEffect, useRef, useCallback } from "react";
import { Button, ButtonGroup, Row, Col } from "react-bootstrap";
import { IntlProvider, FormattedMessage } from "react-intl";
import enMessages from "./locales/en.json";
import arMessages from "./locales/ar.json";
import { ToastContainer, toast } from "react-toastify";
import StudentDetailsStep from "./components/steps/StudentDetailsStep";
import RequiredDocumentsStep from "./components/steps/RequiredDocumentsStep";
import ClinicInformationStep from "./components/steps/ClinicInformationStep";
import moment from "moment";
var Chance = require("chance");
var chance = new Chance();

const App = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");
  const tenantId = queryParameters.get("tenant_id");
  const recaptcha = useRef();
  const version = "2.3";
  const API_URL = process.env.REACT_APP_API_URL;
  const STORAGE_URL = process.env.REACT_APP_PORTAL_URL;
  const messages = {
    en: enMessages,
    ar: arMessages,
  };
  const steps = [
    { name: "step.student_details", step: 1 },
    { name: "step.required_documents", step: 2 },
    { name: "step.clinic_information", step: 3 },
  ];
  const DOCUMENT_TYPES = {
    father: [
      { value: "father_passport", label: "Father Passport" },
      { value: "father_visa", label: "Father Visa" },
      { value: "father_id_1", label: "Father ID Front" },
      { value: "father_id_2", label: "Father ID Back" },
    ],
    mother: [
      { value: "mother_passport", label: "Mother Passport" },
      { value: "mother_visa", label: "Mother Visa" },
      { value: "mother_id_1", label: "Mother ID Front" },
      { value: "mother_id_2", label: "Mother ID Back" },
    ],
    child: [
      { value: "child_passport", label: "Child Passport" },
      { value: "child_visa", label: "Child Visa" },
      { value: "child_id_1", label: "Child ID Front" },
      { value: "child_id_2", label: "Child ID Back" },
      { value: "child_birth_certificate", label: "Birth Certificate" },
      { value: "child_vaccination", label: "Vaccination Card" },
      { value: "child_medical_insurance", label: "Medical Insurance" },
      { value: "child_indemnity", label: "Indemnity Form" },
    ],
    other: [{ value: "other", label: "Other Document" }],
  };

  const chronicIllnesses = [
    "Diabetes Mellitus",
    "Hypertension",
    "Chronic respiratory diseases such as Asthma",
    "Cardiac Disease",
    "Kidney Disease",
    "Liver Disease",
    "Autoimmune Disease",
    "Hematological Disorders",
    "Other",
  ];
  const illnesses = [
    "Chicken Pox",
    "Diphtheria",
    "Infective Hepatitis",
    "Measles",
    "Meningitis",
    "Mumps",
    "Poliomyelitis",
    "Pneumonia",
    "Rheumatic Fever",
    "Scarlet Fever",
    "Tuberculosis",
    "Whooping Cough",
    "Any Other",
  ];
  const conditions = [
    "ADHD",
    "Allergies",
    "Bronchiole Asthma",
    "Congenital Heart Disease",
    "Diabetes Mellitus",
    "Vision Difficulty",
    "Eczema",
    "Epilepsy/Seizure",
    "Febrile Convulsions",
    "Gastric disorders",
    "Hearing Difficulties",
    "Serious Accidents",
  ];
  const errorsObj = {
    center_id: false,
    captcha: false,
    child_name: false,
    birth_date: false,
    joining_date: false,
    gender: false,
    country_id: false,
    father_name: false,
    father_mobile: false,
    father_email: false,
    mother_name: false,
    mother_email: false,
    mother_mobile: false,
  };
  const [locale, setLocale] = useState("en");
  const [countries, setCountries] = useState([]);
  const [errors, setErrors] = useState(errorsObj);
  const [step, setStep] = useState(1);
  const [stepName, setStepName] = useState("step.student_details");
  const [formSaving, setFormSaving] = useState(false);
  const [formData, setFormData] = useState({
    centerData: {
      center_id: "",
      center_uuid: "",
      logo: "",
    },

    childData: {
      admission_id: 0,
      child_id: 0,
      picture: "",
      child_name: "",
      birth_date: "",
      birth_city: "",
      joining_date: "",
      gender: "",
      country_id: "",
      id_number: "",
      passport_number: "",
      passport_validity: "",
      residency_number: "",
      residency_validity: "",
      child_school_attending: "",
      child_bloodgroup: "",
      child_sen: "No",

      allergies: "",
      allergic_reactions: "",
      medicines: "",

      child_medical_name: "",
      child_medical_doctor: "",
      child_medical_clinic: "",
      child_medical_phone: "",
      medical_note: "",
    },

    parentData: {
      parent_id: 0,
      sponsor_name: "",
      grandfather: "",
      phone1: "",
      email1: "",
      employer_father: "",
      position_id_father: "",
      id_number: "",
      parent_education_level: "",
      address: "",

      spouse_name: "",
      spouse_phone: "",
      spouse_email: "",
      employer_mother: "",
      position_id_mother: "",
      spouse_country: "",
      spouse_id_number: "",
      spouse_education_level: "",

      emergency_contact_name: "",
      emergency_contact_relation: "",
      emergency_phone1: "",
      emergency_phone2: "",
    },

    flags: {
      leela_allergies: "No",
      leela_dietry_intolerances: "No",
      leela_special_req: "No",
      check_acknowledgement: 1,
    },
  });

  const [health_declarations, setHealthDeclarations] = useState([]);

  const [chronicIllness, setChronicIllness] = useState("");
  const [chronicIllnessDesc, setChronicIllnessDesc] = useState("");
  const [chronicIllnessDate, setChronicIllnessDate] = useState("");

  const [illness, setIllness] = useState("");
  const [illnessDesc, setIllnessDesc] = useState("");
  const [illnessDate, setIllnessDate] = useState("");

  const [condition, setCondition] = useState("");
  const [conditionDesc, setConditionDesc] = useState("");
  const [conditionDate, setConditionDate] = useState("");
  const [doc, setDoc] = useState({
    father: {
      table_name: "parents",
      table_id: "",
      type: "",
      desc: "",
      file: null,
    },
    mother: {
      table_name: "parents",
      table_id: "",
      type: "",
      desc: "",
      file: null,
    },
    child: {
      table_name: "children",
      table_id: "",
      type: "",
      desc: "",
      file: null,
    },
    other: {
      table_name: "children",
      table_id: "",
      type: "",
      desc: "",
      file: null,
    },
  });
  const [attachments, setAttachments] = useState({
    father: [],
    mother: [],
    child: [],
    other: [],
  });
  const getAdmissionData = useCallback(async () => {
    try {
      const params = new URLSearchParams({
        tenant_id: tenantId || "",
        id: id || "",
      });
      const response = await fetch(`${API_URL}/get-data?${params.toString()}`, {
        method: "GET",
      });
      if (response.ok) {
        const responseData = await response.json();
        const {
          centerData,
          childData,
          childHealthData,
          countriesData,
          parentData,
          attachments,
        } = responseData.data;
        setAttachments(attachments);
        setCountries(countriesData);
        setFormData((prev) => ({
          ...prev,

          centerData: {
            ...prev.centerData,
            center_id: centerData.center_id,
            center_uuid: centerData.center_uuid,
            logo: centerData.logo,
          },

          childData: {
            ...prev.childData,
            child_id: childData.child_id,
            child_name: childData.child_name,
            picture: childData.picture,
            child_sen: childData.child_sen,
            birth_date: childData.birth_date,
            birth_city: childData.birth_city,
            joining_date: childData.joining_date,
            gender: childData.gender,
            country_id: childData.country_id,
            id_number: childData.id_number,
            passport_number: childData.passport_number,
            passport_validity: childData.passport_validity,
            residency_number: childData.residency_number,
            residency_validity: childData.residency_validity,
            child_school_attending: childData.child_school_attending,
            child_bloodgroup: childData.child_bloodgroup,
            medical_note: childData.medical_note,
            child_medical_name: childData.child_medical_name,
            child_medical_doctor: childData.child_medical_doctor,
            child_medical_clinic: childData.child_medical_clinic,
            child_medical_phone: childData.child_medical_phone,
          },

          parentData: {
            ...prev.parentData,
            parent_id: parentData.parent_id,
            sponsor_name: parentData.sponsor_name,
            grandfather: parentData.grandfather,
            phone1: parentData.phone1,
            email1: parentData.email1,
            employer_father: parentData.employer_father,
            position_id_father: parentData.position_id_father,
            id_number: parentData.id_number,
            country_id: parentData.country_id,
            parent_education_level: parentData.parent_education_level,
            address: parentData.address,
            spouse_name: parentData.spouse_name,
            spouse_phone: parentData.spouse_phone,
            spouse_email: parentData.spouse_email,
            employer_mother: parentData.employer_mother,
            position_id_mother: parentData.position_id_mother,
            spouse_country: parentData.spouse_country,
            spouse_education_level: parentData.spouse_education_level,
            spouse_id_number: parentData.spouse_id_number,

            emergency_contact_name: parentData.emergency_contact_name,
            emergency_contact_relation: parentData.emergency_contact_relation,
            emergency_phone1: parentData.emergency_phone1,
          },
        }));
        if (childHealthData.length > 0) {
          const healthDeclarations = childHealthData.map((item) => ({
            ...item,
            uuid: chance.guid(),
          }));
          setHealthDeclarations(healthDeclarations);
        }
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  }, [API_URL, id, tenantId]);

  useEffect(() => {
    if (id) {
      getAdmissionData();
    }
  }, [getAdmissionData, id]);
  const handleLanguageChange = (event) => {
    setLocale(event.target.value);
  };
  const handleChange = (e, section) => {
    const { name, value } = e.target;

    if (name.startsWith("child_use_toilet_")) {
      const index = parseInt(name.split("_")[3], 10);
      const child_use_toilet = [...formData.childData.child_use_toilet];
      child_use_toilet[index] = value;

      setFormData((prev) => ({
        ...prev,
        childData: {
          ...prev.childData,
          child_use_toilet,
        },
      }));
    } else if (section === "child") {
      setFormData((prev) => ({
        ...prev,
        childData: {
          ...prev.childData,
          [name]: value,
        },
      }));
    } else if (section === "parent") {
      setFormData((prev) => ({
        ...prev,
        parentData: {
          ...prev.parentData,
          [name]: value,
        },
      }));
    } else if (section === "center") {
      setFormData((prev) => ({
        ...prev,
        centerData: {
          ...prev.centerData,
          [name]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const validateStep = () => {
    let isValid = true;
    const errorsObj = {};

    if (step === 1) {
      const captchaValue = recaptcha.current?.getValue();

      if (!captchaValue) {
        errorsObj.captcha = true;
        isValid = false;
      }

      /* ---------- Center ---------- */
      if (!formData.centerData.center_id) {
        errorsObj.center_id = true;
        isValid = false;
      }

      /* ---------- Child ---------- */
      if (!formData.childData.child_name) {
        errorsObj.child_name = true;
        isValid = false;
      }

      if (!formData.childData.birth_date) {
        errorsObj.birth_date = true;
        isValid = false;
      }

      if (!formData.childData.gender) {
        errorsObj.gender = true;
        isValid = false;
      }

      if (!formData.childData.country_id) {
        errorsObj.country_id = true;
        isValid = false;
      }

      /* ---------- Father ---------- */
      if (!String(formData.parentData.id_number ?? "").trim()) {
        errorsObj.parent_id_number = true;
        isValid = false;
      }
      if (!formData.parentData.email1?.trim()) {
        errorsObj.email1 = true;
        isValid = false;
      }

      /* ---------- Mother ---------- */
      if (!String(formData.parentData.spouse_id_number ?? "").trim()) {
        errorsObj.spouse_id_number = true;
        isValid = false;
      }
      if (!formData.parentData.spouse_email?.trim()) {
        errorsObj.spouse_email = true;
        isValid = false;
      }
    }

    setErrors(errorsObj);
    return isValid;
  };
  const handleNextStep = () => {
    handleSubmit(null);
  };

  const handleSubmit = async (jumpStep) => {
    if (!validateStep()) {
      if (errorsObj.captcha) {
        toast.error(<FormattedMessage id="validation.captcha_required" />);
      } else {
        toast.warning(
          <FormattedMessage id="validation.fill_required_fields" />,
        );
      }
      return;
    }

    setFormSaving(true);

    try {
      const fD = new FormData();
      const formDataObj = structuredClone(formData);
      formDataObj.tenant_id = tenantId || "";
      fD.append("formData", JSON.stringify(formDataObj));

      fD.append("step", step);
      fD.append("tenant_id", tenantId || "");
      if (step === 1) {
        const captchaValue = recaptcha.current?.getValue();
        fD.append("g-recaptcha-response", captchaValue);
      }

      fD.append(
        "health_declarations",
        JSON.stringify(
          health_declarations.map((h) => ({
            child_health_id: Number(h.child_health_id || 0),
            child_health_type: h.child_health_type,
            child_health_name: h.child_health_name,
            child_health_desc: h.child_health_desc,
            child_health_date: h.child_health_date
              ? moment(h.child_health_date).format("YYYY-MM-DD")
              : null,
          })),
        ),
      );

      const updateParams = new URLSearchParams({
        tenant_id: tenantId || "",
      });
      const response = await fetch(
        `${API_URL}/update-data?${updateParams.toString()}`,
        {
        method: "POST",
        body: fD,
        },
      );

      if (response.ok) {
        const responseJson = await response.json();
        const { data, type, message } = responseJson;

        if (type) {
          const { centerData, childData, childHealthData, parentData } = data;

          console.log(
            "Response Data:",
            centerData,
            childData,
            childHealthData,
            parentData,
          );

          setFormData((prev) => ({
            ...prev,
            centerData: {
              ...prev.centerData,
              ...centerData,
            },
            childData: {
              ...prev.childData,
              ...childData,
            },
            parentData: {
              ...prev.parentData,
              ...parentData,
            },
          }));

          if (Array.isArray(childHealthData)) {
            const healthDeclarations = childHealthData.map((item) => ({
              ...item,
              uuid: chance.guid(),
            }));
            setHealthDeclarations(healthDeclarations);
          }
          let stepNum = step;

          if (step < steps.length && !jumpStep) {
            stepNum = step + 1;
          } else if (jumpStep) {
            stepNum = jumpStep;
          }

          setStep(stepNum);
          setStepName(steps[stepNum - 1].name);

          toast.success(
            <FormattedMessage id="validation.saved_successfully" />,
          );
        } else {
          message && toast.info(message);
        }
      } else {
        console.log("Error submitting form");
      }
    } catch (error) {
      console.log("Something went wrong!", error);
    } finally {
      setFormSaving(false);
    }
  };
  const addHealthDeclaration = (child_health_type) => {
    const healthDeclaration = {
      child_health_name: "",
      child_health_desc: "",
      child_health_date: "",
    };

    if (child_health_type === "Chronic Illness") {
      if (!chronicIllness || !chronicIllnessDesc || !chronicIllnessDate) {
        toast.error(
          <FormattedMessage id="validation.fill_all_chronic_illness_fields" />,
        );
        return;
      }

      healthDeclaration.child_health_name = chronicIllness;
      healthDeclaration.child_health_desc = chronicIllnessDesc;
      healthDeclaration.child_health_date = chronicIllnessDate;
    } else if (child_health_type === "Illness") {
      if (!illness || !illnessDesc || !illnessDate) {
        toast.error(
          <FormattedMessage id="validation.fill_all_illness_fields" />,
        );
        return;
      }

      healthDeclaration.child_health_name = illness;
      healthDeclaration.child_health_desc = illnessDesc;
      healthDeclaration.child_health_date = illnessDate;
    } else if (child_health_type === "Condition") {
      if (!condition || !conditionDesc || !conditionDate) {
        toast.error(
          <FormattedMessage id="validation.fill_all_condition_fields" />,
        );
        return;
      }

      healthDeclaration.child_health_name = condition;
      healthDeclaration.child_health_desc = conditionDesc;
      healthDeclaration.child_health_date = conditionDate;
    }

    setHealthDeclarations((prevHealthDeclarations) => [
      ...prevHealthDeclarations,
      {
        child_health_id: 0,
        uuid: chance.guid(),
        child_health_type,
        ...healthDeclaration,
      },
    ]);

    if (child_health_type === "Chronic Illness") {
      setChronicIllness("");
      setChronicIllnessDesc("");
      setChronicIllnessDate("");
    } else if (child_health_type === "Illness") {
      setIllness("");
      setIllnessDesc("");
      setIllnessDate("");
    } else if (child_health_type === "Condition") {
      setCondition("");
      setConditionDesc("");
      setConditionDate("");
    }
  };
  const removeHealthDeclaration = (uuid) => {
    setHealthDeclarations((prevHealthDeclarations) =>
      prevHealthDeclarations.filter(
        (healthDeclaration) => healthDeclaration.uuid !== uuid,
      ),
    );
  };

  const stepContext = {
    recaptcha,
    formData,
    setFormData,
    errors,
    countries,
    handleChange,
    STORAGE_URL,
    tenantId,
    DOCUMENT_TYPES,
    doc,
    setDoc,
    attachments,
    setAttachments,
    chronicIllnesses,
    illnesses,
    conditions,
    chronicIllness,
    setChronicIllness,
    chronicIllnessDesc,
    setChronicIllnessDesc,
    chronicIllnessDate,
    setChronicIllnessDate,
    illness,
    setIllness,
    illnessDesc,
    setIllnessDesc,
    illnessDate,
    setIllnessDate,
    condition,
    setCondition,
    conditionDesc,
    setConditionDesc,
    conditionDate,
    setConditionDate,
    health_declarations,
    addHealthDeclaration,
    removeHealthDeclaration,
  };

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <div id="page" dir={locale === "en" ? "ltr" : "rtl"}>
        <aside id="sidebar" className="d-none d-md-block position-relative">
          <small
            className="text-muted"
            style={{
              position: "absolute",
              bottom: 20,
              left: locale === "en" ? 20 : "auto",
              right: locale === "ar" ? 20 : "auto",
            }}
          >
            v{version}
          </small>
          <Row className="aside-header">
            <Col>
              <img
                src={formData.centerData.logo}
                alt="Educore"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Col>
            <Col className="lang-switcher text-end">
              <ButtonGroup>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="en"
                  variant={locale === "en" ? "secondary" : "light"}
                >
                  EN
                </Button>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="ar"
                  variant={locale === "ar" ? "secondary" : "light"}
                >
                  AR
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="steps-list">
            <ul>
              {steps.map((item, index) => (
                <li key={index} className={step === index + 1 ? "active" : ""}>
                  <Button
                    variant="link"
                    onClick={() => {
                      handleSubmit(index + 1);
                    }}
                  >
                    <FormattedMessage id={item.name} />
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </aside>
        <div id="content">
          <Row className="res-header d-md-none">
            <Col>
              <img
                src={formData.centerData.logo}
                alt="Educore"
                style={{ maxWidth: "100%", height: "150px" }}
              />
            </Col>
            <Col className="lang-switcher text-end">
              <ButtonGroup>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="en"
                  variant={locale === "en" ? "secondary" : "light"}
                >
                  EN
                </Button>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="ar"
                  variant={locale === "ar" ? "secondary" : "light"}
                >
                  AR
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div id="content_child" className="position-relative">
            <div className="form-nav">
              <Button
                variant={step === steps.length ? "success" : "primary"}
                onClick={handleNextStep}
                disabled={formSaving}
              >
                <FormattedMessage
                  id={step === steps.length ? "submit" : "next"}
                />
              </Button>
            </div>
            <h2 className="mb-3">
              <FormattedMessage id={stepName} />
            </h2>

            {step === 1 && <StudentDetailsStep ctx={stepContext} />}

            {step === 2 && <RequiredDocumentsStep ctx={stepContext} />}

            {step === 3 && <ClinicInformationStep ctx={stepContext} />}
          </div>
        </div>
      </div>
      <ToastContainer
        position={locale === "en" ? "bottom-right" : "bottom-left"}
        rtl={locale === "ar"}
        hideProgressBar={true}
        theme="colored"
      />
    </IntlProvider>
  );
};

export default App;
